import { reactive, computed } from '@vue/composition-api';

const state = reactive({
  products: [],
  filterProductsCount: 0,
  loading: false,
  filtersActive: false,
  allProductsLoaded: false,
  infiniteId: +new Date(),
});

export default function useCollection() {
  function setProducts(products, count) {
    state.products = products;
    state.allProductsLoaded = (count > 0 && state.products.length >= count) || (state.products.length > 0 && products.length === 0);
    if (!state.allProductsLoaded) {
      state.infiniteId += 1;
    }
    state.filterProductsCount = count;
  }

  function setLoading(status) {
    state.loading = status;
  }

  function setFiltersActive(status) {
    state.filtersActive = status;
  }

  return {
    state,
    setProducts,
    setLoading,
    setFiltersActive,
  };
}
